import i18next from "src/i18n/config";

import { ProvisioningEvents } from "@dashboard/devices/types";
import { getEventColors } from "@dashboard/overview/components/EventChartCard/EventChartCard.utils";
import { Theme } from "@mui/material";

import { getActorTitle } from "./shared/eventHelpers";
import type { EventContentResult, EventContext, RendererProps } from "./shared/eventTypes";
import { renderUnknownEventContent } from "./unknown";

type ProvisioningChangedEvent = Extract<ProvisioningEvents, { eventTypeName: "ProvisioningEvent.Changed" }>;
const renderProvisioningChanged = (props: RendererProps<ProvisioningChangedEvent>): EventContentResult | null => {
    const { event, theme } = props;
    const eventColors = getEventColors(theme);
    const actorTitle = getActorTitle(event);

    const actorLabel = actorTitle ?? i18next.t("common:status.unknown");

    return {
        color: eventColors[event.level],
        header: i18next.t("modals:eventModals.provisioningChangedTitle"),
        component: i18next.t("modals:eventModals.provisioningChangedDescription", {
            actorTitle: actorLabel,
            entityId: event.entityId,
        }),
    };
};

export const renderProvisioningEventContent = (
    event: ProvisioningEvents,
    context: EventContext,
    theme: Theme,
): EventContentResult | null => {
    switch (event.eventTypeName) {
        case "ProvisioningEvent.Changed":
            return renderProvisioningChanged({ event, context, theme });
        default:
            return renderUnknownEventContent({ event, context, theme });
    }
};
